import './bml-contact-faq.scss';

const TEMPLATE = `
<section class="maps container-fluid fade-up">
    <div class="row">
        <div class="col-md-6">
            <p class="section-label" data-animate-child>Питання та відповіді</p>
        </div>
        <div class="col-md-6">
            <h3 data-animate-child>Питання та відповіді (FAQ)</h3>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чи можна отримати другу думку за готовими гістологічними препаратами?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Так, у багатьох випадках можлива консультація готових гістологічних препаратів — скелець, блоків або цифрових зображень препаратів, якщо вони відповідають вимогам якості.</p>
                    <p data-animate-child>Друга думка може бути корисною у складних, рідкісних або онкологічних випадках, а також тоді, коли лікар або пацієнт потребує додаткового підтвердження діагнозу. Для консультації бажано надати попередній висновок, клінічну інформацію та всі наявні матеріали, пов'язані з випадком.</p>
                    <p data-animate-child>Ми оцінимо якість гістологічних препаратів, якщо скельця невисокої якості, то, для точності діагнозу, ми виготовимо з готового гістологічного блоку додаткові гістологічні скельця.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чому для дослідження важлива клінічна інформація?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Клінічна інформація допомагає лікарю-патологу правильно інтерпретувати мікроскопічні зміни у тканині. Для точного висновку можуть бути важливими локалізація процесу, попередній клінічний діагноз, анамнез, результати обстежень, опис операційного матеріалу або фото ураження.</p>
                    <p data-animate-child>Клінічні дані не замінюють мікроскопічне дослідження, але дозволяють зробити патогістологічний висновок більш точним, інформативним і корисним для лікаря, який веде пацієнта.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Скільки часу виконується патогістологічне дослідження?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Строк виконання залежить від типу матеріалу, його об'єму, складності випадку та потреби в додаткових методах дослідження.</p>
                    <p data-animate-child>У стандартних випадках результат зазвичай готується за 5 робочих днів. Водночас складні випадки можуть потребувати додаткових зрізів, дофіксації, декальцинації, гістохімічного чи імуногістохімічного дослідження, а також консультації кількох фахівців. Подовження строку в таких ситуаціях є частиною якісного діагностичного процесу.</p>
                    <p data-animate-child>За потреби Замовника патогістологічне дослідження можна замовити з терміновим виконанням – 2 робочі дні.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Як правильно підготувати матеріал для патогістологічного дослідження?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Матеріал має бути одразу після забору поміщений у контейнер із фіксуючим розчином, найчастіше — 10% нейтральним забуференим формаліном. Контейнер повинен бути щільно закритий, промаркований і супроводжуватися направленням.</p>
                    <p data-animate-child>У направленні необхідно вказати дані пацієнта, локалізацію матеріалу, попередній клінічний діагноз, дату забору, дані лікаря та медичного закладу.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чому важливо правильно маркувати контейнер із біоматеріалом?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Правильне маркування забезпечує точну ідентифікацію пацієнта та зразка на всіх етапах дослідження. На контейнері мають бути зазначені щонайменше ПІБ пацієнта, дата народження або інший ідентифікатор, локалізація матеріалу та дата забору.</p>
                    <p data-animate-child>Невідповідність маркування або відсутність даних може ускладнити або затримати виконання дослідження, оскільки лабораторія повинна гарантувати безпеку та достовірність результату.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чи можна передати на дослідження кілька фрагментів тканини?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Так, кілька фрагментів тканини можуть бути передані на дослідження. Якщо матеріал отримано з різних анатомічних ділянок або має різне клінічне значення, бажано розміщувати його в окремих контейнерах із чітким маркуванням кожного зразка.</p>
                    <p data-animate-child>Це допомагає лікарю-патологоанатому точно співвіднести мікроскопічні зміни з конкретною локалізацією та надати більш інформативний висновок.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Що таке імуногістохімічне дослідження?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Імуногістохімічне дослідження — це додатковий метод діагностики, який дозволяє виявити у тканині певні білки або маркери за допомогою спеціальних антитіл.</p>
                    <p data-animate-child>Його застосовують для уточнення походження пухлини, визначення її типу, оцінки окремих прогностичних або предиктивних маркерів, а також у складних випадках, коли стандартного гістологічного дослідження недостатньо.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чи завжди після патогістологічного дослідження потрібне імуногістохімічне дослідження?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Ні, імуногістохімічне дослідження потрібне не завжди. У багатьох випадках діагноз можна встановити за результатами стандартного патогістологічного дослідження.</p>
                    <p data-animate-child>Імуногістохімія рекомендується тоді, коли необхідно уточнити діагноз, підтвердити тип пухлини, визначити її походження або отримати додаткову інформацію, важливу для подальшої тактики лікування.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чи можна досліджувати матеріал, який уже тривалий час зберігався у формаліні?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>У багатьох випадках матеріал, який певний час зберігався у формаліні, може бути придатним для дослідження. Водночас тривале або неправильне зберігання може впливати на якість тканини та можливість виконання додаткових методів, зокрема імуногістохімії.</p>
                    <p data-animate-child>Остаточну придатність матеріалу лабораторія оцінює після його отримання та первинного огляду.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Що відбувається з матеріалом після завершення дослідження?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Після завершення дослідження виготовлені гістологічні препарати, парафінові блоки та супровідна документація зберігаються в архівах лабораторії відповідно до встановлених правил і внутрішніх процедур.</p>
                    <p data-animate-child>За потреби ці матеріали можуть бути використані для додаткових досліджень, консультації складного випадку або отримання другої думки.</p>
                </div>
            </div>

            <div class="mb-accordion accordion-main accordion-map container-fluid" data-animate-child>
                <div class="row">
                    <div class="col-10">
                        <h4 class="head-accordion" data-animate-child>Чи може пацієнт отримати блоки або скельця для консультації в іншій лабораторії?</h4>
                    </div>
                    <div class="col-2 d-flex justify-content-end align-items-start">
                        <img class="open-accordion" src="/images/button-close-accordion.svg" alt="close-accordion-btn">
                        <img class="close-accordion" src="/images/button-open-accordion.svg" alt="open-accordion-btn">
                    </div>
                </div>
                <div class="accordion-inner">
                    <p data-animate-child>Так, за письмовим запитом, встановленого зразка, пацієнта або його законного представника лабораторія може видати гістологічні препарати або парафінові блоки для консультації в іншому медичному закладі.</p>
                    <p data-animate-child>Зазвичай для цього потрібно оформити письмовий запит і підтвердити особу отримувача або право представляти інтереси пацієнта.</p>
                </div>
            </div>

        </div>
    </div>
</section>
`;

class BmlContactFaq extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-contact-faq', BmlContactFaq);
